module.exports = __webpack_public_path__ + "img/ca11aabe20d673c52d153f601fe65f24.png";